/**
 * 微影的备用文案，不能出现hikvision
 * */
const message = {}

const classroomModule = {}

const courseModule = {}

const examModule = {}

const myLearningModule = {}

const vatModule = {}

// 首页
const homeModule = {
  'home.hikCertiTitle': 'Hikmicro Security Certification Program',
  'home.hikCertiDesc': "The Hikmicro Security Certification Program revolves around Hikmicro products and solutions, covering system configuration, operation, troubleshooting, and more. This program aims to enable quick transfer of Hikmicro's product and technical capabilities to distributors, system integrators, and installers.",
  'home.trainerDesc': 'Hikmicro eLearning platform has brought together a professional and international team of trainers – Hikmicro Certified Instructors – including in-house instructors and instructors from third-party institutions.   Each of our talented and experienced instructors is a good mentor for your quick learning and development in the security industry.',
  'home.buildSkillDesc': 'Hikmicro eLearning platform aims to help security-industry practitioners enhance their professional competence through learning and certification. The platform also provides preliminary training and insights for those who wish to start out in the security industry. We welcome installers, integrators, engineers, students, and anyone else who is interested in the security industry to use this platform for training and certification. We will help you manage your training certificates, enhance your resume, and stay ahead of competitors.'
}

// 认证相关
const certificateModule = {
  'certificate.ruleBDetail': 'For self-paced training, you need to complete all compulsory courses and some elective courses to gain enough credits (9 credits for Hikmicro Security Certification; 12 credits for General Security Certification) before taking the exam.',
  'certificate.ruleC': 'c.',
  'certificate.ruleCDetail': 'For instructor-led training, you need to complete the online or onsite training delivered by Hikmicro certified trainers before taking the exam.',
  'certificate.enroll.ndTrainerTip': `We would like to inform you that as part of your training, we will need to transfer some of your personal information to a third-party trainer. The transfer of your data will be done in accordance with the General Data Protection Regulation (GDPR), and we will ensure that your personal information is protected to the same standards as it is with us.

    The transfer of your data is solely for the purpose of facilitating your training, and the third-party trainer will be bound by the same obligations of confidentiality and data protection as we are. They will only use your personal information for the purpose of delivering the training and will not share it with any other third party.
    
    If you have any concerns or questions about the transfer of your personal information, please do not hesitate to contact us.
    
    Best regards,
    Hikmicro UK`
}

// 认证首页-由于区分gsc / hsc
const certificateListModule = {
  'hscCertificate.publicTip': "Hikmicro's certificate training can:",
  'gscCertificate.publicTip': "Hikmicro's certificate training can:",
  'gscCertificate.title': 'Hikmicro Outdoor Certification',
  'hscCertificate.title': 'Hikmicro Security Certification',
  'hscCertificate.desc': 'This program is open to security professionals who need to deploy Hikmicro systems and look for ways to prove their skill and expertise in the security industry.\n\nYou will be qualified as a Hikmicro Certified Security Associate, Hikmicro Certified Security Professional or Hikmicro Certified Security Expert once you finish the relevant courses and exams. Please note that you have to start the certification from the primary level. You have to get an HCSA certificate before you can apply for an HCSP certificate.',
  'hscCertificate.traningOne': "Provide knowledge about Hikmicro's variety of product offerings, packages, and solutions, and ways to select products and deploy systems."
}

// gdpr
const GDPRModule = {
  'gdpr.provider.companyName': 'HIKMICRO'
}

const searchModule = {
}

const topicModule = {
}

const trainerTeamModule = {
  'trainerTeam.overview': "The Hikmicro eLearning trainers' team features the most experienced security experts from Hikmicro and partner organizations worldwide. These trainers come from professional fields including product design, AI algorithm research, pre-sales, delivery, after-sales, customer training, and more. \nThey are well-equipped to provide authoritative courses about cutting-edge products and solutions and to prepare you for the security industry today and tomorrow.",
  'trainerTeam.joinTeamReasonOne': 'Independently or assist the teaching team to carry out security-related course topics and content validation, course material collection and compilation, course update and development, course review and release, etc. according to Hikmicro eLearning course development and management rules',
  'trainerTeam.joinTeamReasonTwo': 'Deliver courses online and onsite as authorized by Hikmicro eLearning platform, including the organization of classes, exams, certificate issuance, etc.',
  'trainerTeam.joinTeamReasonThree': 'Create and review video courses in accordance with course production and review requirements, and with the authorization of Hikmicro eLearning platform',
  'trainerTeam.getReward': "You'll get the following regarding Hikmicro eLearning courses",
  'trainerTeam.dialogTips': 'You acknowledge and agree that the information collected by us above is to be used for convenient contact, qualification review, and screening. We will review your resume and inform you of our decision within 7 business days of submission. Please note that submission of a resume alone is not sufficient to become a trainer. If Hikmicro declines your application to become a trainer, all personal data submitted to us through this webpage will be automatically deleted within 3 business days.',
  'trainerTeam.joinUsDesc': 'If you have professional experience in the security industry and are excited about sharing your knowledge, Hikmicro eLearning cordially invites you to join our team of course developers and instructors.'
}

// 实操练习
const handsOnModule = {
  'handsOn.mobileUnavailable': "I'm sorry that the hands-on practice is not available on mobile devices temporarily, please log in to the web portal of Hikmicro eLearning. Thank you.",
  'handsOn.mobileIframeUnavailable': "I'm sorry that the hands-on practice/ practical exam is not available on mobile devices temporarily, please log in to the web portal of Hikmicro eLearning. Thank you."
}

// 实操考试
const practicalExamModule = {
  'practicalExam.skillLearn.mobileUnavailableTip': "I'm sorry that the practical exam is not available on mobile devices temporarily, please log in to the web portal of Hikmicro eLearning. Thank you."
}

const invitationModule = {
  'invitation.title': 'Hikmicro eLearning Training Invitation'
}

// 全局
const globalModule = {
  'footer.contactEmail': 'eLearninglobal@Hikmicro.com',
  'header.generalSecurityCertification': 'Hikmicro Outdoor Certification',
  'header.hikSecurityCertification': 'Hikmicro Security Certification',
  'global.GSCOveriewDesc': 'The General Security Certification Program focuses on the universal knowledge and skills needed in the security industry, from technical principles to typical solution design.',
  'global.HSCOveriewDesc': 'The Hikmicro Security Certification Program revolves around Hikmicro products and solutions, covering system configuration, operation, troubleshooting, and more.',
  'global.copyrightInfo': '2022 Hangzhou Hikmicro Digital Technology Co., Ltd.All Rights Reserved.'
}

const newsModule = {
}

// 错误和异常
const exceptionModule = {
  'error.30000': 'Failed to get the exam paper, please send an email to eLearninglobal@hikmicrotech.com with the screenshot and the occurrence time.',
  'error.30001': 'Failed to submit the answer, please send an email to eLearninglobal@hikmicrotech.com with the screenshot and the occurrence time.',
  'error.30002': 'Failed to start the exam, please send an email to eLearninglobal@hikmicrotech.com with the screenshot and the occurrence time.',
  'error.30003': 'Failed to renew the exam, please send an email to eLearninglobal@hikmicrotech.com with the screenshot and the occurrence time.'
}

Object.assign(message, {
  ...homeModule,
  ...classroomModule,
  ...exceptionModule,
  ...globalModule,
  ...courseModule,
  ...certificateModule,
  ...GDPRModule,
  ...examModule,
  ...myLearningModule,
  ...searchModule,
  ...trainerTeamModule,
  ...certificateListModule,
  ...handsOnModule,
  ...practicalExamModule,
  ...invitationModule,
  ...newsModule,
  ...vatModule,
  ...topicModule
})

export default message
